import React from 'react';

import { BaseDialog } from '@metarouter-private/mr-mui';

import useDeployProgressModalProps from './useDeployProgressModalProps';
import DeployProgressContent from './DeployProgressContent';
import DeployProgressActions from './DeployProgressActions';

export default function DeployProgressModal() {
  const {
    DialogProps,
    isDeploying,
    isComplete,
    completed,
    total,
    failedDeployments,
    onClose,
    onReload,
    onBackToPipelines,
  } = useDeployProgressModalProps();

  return (
    <BaseDialog
      DialogProps={DialogProps}
      title="Bulk Deployment"
      content={
        <DeployProgressContent
          isDeploying={isDeploying}
          completed={completed}
          total={total}
          failedDeployments={failedDeployments}
        />
      }
      actions={
        <DeployProgressActions
          isComplete={isComplete}
          onClose={onClose}
          onReload={onReload}
          onBackToPipelines={onBackToPipelines}
        />
      }
      data-test-id="deployProgressModal"
    />
  );
}
